export const INITIAL_VALUE = 0
export const ITEMS_PER_PAGE = 5
